import { SocialAuthService } from '@abacritt/angularx-social-login';
import {
  Component,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/libs/auth/auth.service';
import { WebauthnService } from 'src/libs/auth/webauthn.service';
import { DiscordLoginProvider } from 'src/libs/oauth/providers/Discord.login-provider';
import { LoginHeaderService } from 'src/libs/state/login-header.service';
import { StateService } from 'src/libs/state/state.service';

@Component({
  selector: 'fini-login-login',
  templateUrl: './login-login.component.html',
  styleUrls: ['./login-login.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginLoginComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private router: Router,
    private toast: HotToastService,
    private social: SocialAuthService,
    private route: ActivatedRoute,
    private state: StateService,
    private webAuthnService: WebauthnService,
    private header: LoginHeaderService,
  ) {
    // Push header data up the tree
    this.header.set({
      title: 'Login',
      subtitle: 'Welcome back! Login below to continue',
    });
  }

  loading = signal(false);
  showMfa$ = new BehaviorSubject(false);
  isProduction = signal(environment.production);

  username = '';
  password = '';
  passkey = signal('');

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    const params = this.route.snapshot.queryParams;
    this.auth.redirectUrl = params['redirect'] || '';
    if (params['code']) {
      // hot fix this again, 23/01/2025
      const lastDiscordLogin = this.state.get('lastDiscordLogin');
      if (lastDiscordLogin && Date.now() - lastDiscordLogin < 10_000) {
        return;
      }

      const idToken = params['code'];
      this.loading.set(true);
      this.state.set({ lastDiscordLogin: Date.now() });

      this.auth.loginSocial(idToken, 'discord').subscribe();
    } else {
      this.auth.profile().subscribe((profile) => {
        // if (profile) {
        //   this.router.navigate(['dashboard']);
        // }
      });
    }
  }

  login() {
    const username = this.username;
    const password = this.password;

    if (!username || !password) {
      this.toast.error('Fill in a username and a password');
      return;
    }

    this.loading.set(true);
    this.auth.login({ username, password }).subscribe(() => {
      this.loading.set(false);
    });
  }

  loginDiscord() {
    this.loading.set(true);
    try {
      this.social.signIn(DiscordLoginProvider.PROVIDER_ID);
      if (this.auth.redirectUrl) {
        if (this.auth.redirectUrl.startsWith('/')) {
          this.router.navigate([this.auth.redirectUrl]);
        } else {
          window.location.href = this.auth.redirectUrl;
        }
      }
    } catch {
    } finally {
      this.loading.set(false);
    }
  }

  async loginPasskey() {
    if (environment.production) {
      this.toast.error('Passkey login is not available in production');
      return;
    }
    this.loading.set(true);

    try {
      const { success, token } = await this.webAuthnService.authenticate(
        this.username,
      );
      if (!success) {
        this.toast.error('Login failed');
        return;
      }

      this.state.set({ token });

      this.toast.success('Login successful!');
      this.router.navigate(['profile']);
    } catch (err) {
      this.toast.error(`Login failed. ${err}`);
    } finally {
      this.loading.set(false);
    }
  }
}
